import styles from './Checkbox.module.css'
import { InputHTMLAttributes } from 'react'
interface CheckboxProps{
    caption: string
    checked: boolean | undefined | null
    id?: string
    name?: string
    disabled?: boolean
    placeholder?: string
    onChange: (event: any) => void
}

export const Checkbox = (props: CheckboxProps): JSX.Element => {
    const {
        caption,
        id,
        checked,
        name,
        disabled = false,
        onChange
    } = props

    const checkboxId = id || `checkbox-${caption.replace(/\s+/g, '-').toLowerCase()}`;
    const handleInputChange = (event: any) => {
        onChange?.(event)
    }

    const value = checked ? checked : false

    return (
        <label htmlFor={checkboxId} className={styles.Checkbox__Label}>
            <span className={styles.Checkbox__Container}>
                <input
                    type="checkbox"
                    checked={value}
                    onChange={handleInputChange}
                    disabled={disabled}
                    className={styles.Checkbox__Input}
                />
                <span className={styles.Checkbox__IconContainer}>
                    <svg 
                        className={styles.Checkbox__Icon} 
                        width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6L7.5 12.5L19 1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </span>
            <span className={styles.Checkbox__Caption}>{caption}</span>  
        </label>
    )
}